import { createAction } from 'redux-actions';

const namespace = 'crdf.journeys.NolCreatedModal';

export const CLOSE_NOL_CREATED_MODAL = `${namespace}.closeNolCreatedModal`;

export const closeNolCreatedModal = createAction(CLOSE_NOL_CREATED_MODAL);
